"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ObserverProvider = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constant = _interopRequireDefault(require("lodash/constant"));

var _forEach = _interopRequireDefault(require("lodash/forEach"));

var _noop = _interopRequireDefault(require("lodash/noop"));

var _pull = _interopRequireDefault(require("lodash/pull"));

var _size = _interopRequireDefault(require("lodash/size"));

var _excluded = ["onChange", "as"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var INTERSECTION_OBSERVER_THRESHOLD = .99;

var ObserverContext = /*#__PURE__*/_react["default"].createContext([(0, _constant["default"])(_noop["default"])]);

var NOOP_OBSERVER = {
  observe: _noop["default"],
  unobserve: _noop["default"],
  disconnect: _noop["default"]
};

var useIntersectionObserver = function useIntersectionObserver(cb) {
  var ref = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    return function () {
      return ref.current && ref.current.disconnect();
    };
  }, []);

  if (!ref.current) {
    ref.current = NOOP_OBSERVER;

    if (window.IntersectionObserver && window.IntersectionObserverEntry) {
      ref.current = new IntersectionObserver(cb, {
        root: null,
        threshold: INTERSECTION_OBSERVER_THRESHOLD
      });
    }
  }

  var observe = (0, _react.useCallback)(function (node) {
    return ref.current.observe(node);
  }, []);
  var unobserve = (0, _react.useCallback)(function (node) {
    return ref.current.unobserve(node);
  }, []);
  return [observe, unobserve];
};

var ObserverProvider = function ObserverProvider(_ref) {
  var children = _ref.children;
  var mapping = (0, _react.useRef)(new WeakMap());

  var _useIntersectionObser = useIntersectionObserver(function (entries) {
    (0, _forEach["default"])(entries, function (entry) {
      (0, _forEach["default"])(mapping.current.get(entry.target), function (cb) {
        return cb(entry);
      });
    });
  }),
      _useIntersectionObser2 = (0, _slicedToArray2["default"])(_useIntersectionObser, 2),
      observe = _useIntersectionObser2[0],
      unobserve = _useIntersectionObser2[1];

  var value = (0, _react.useMemo)(function () {
    var sharedObserve = function sharedObserve(node, cb) {
      if (mapping.current.has(node)) {
        mapping.current.get(node).push(cb);
      } else {
        mapping.current.set(node, [cb]);
        observe(node);
      }

      return function () {
        (0, _pull["default"])(mapping.current.get(node), cb);

        if ((0, _size["default"])(mapping.current.get(node)) === 0) {
          mapping.current["delete"](node);
          unobserve(node);
        }
      };
    };

    return [sharedObserve];
  }, [observe, unobserve]);
  return /*#__PURE__*/_react["default"].createElement(ObserverContext.Provider, {
    value: value
  }, children);
};

exports.ObserverProvider = ObserverProvider;
ObserverProvider.propTypes = {
  children: _propTypes["default"].any.isRequired
};

var TrackInView = function TrackInView(_ref2) {
  var onChange = _ref2.onChange,
      _ref2$as = _ref2.as,
      Elem = _ref2$as === void 0 ? 'div' : _ref2$as,
      rest = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
  var nodeRef = (0, _react.useRef)(null);

  var _useContext = (0, _react.useContext)(ObserverContext),
      _useContext2 = (0, _slicedToArray2["default"])(_useContext, 1),
      observe = _useContext2[0];

  (0, _react.useEffect)(function () {
    var unobserve = observe(nodeRef.current, function (entry) {
      onChange(!!entry.isIntersecting);
    });
    return function () {
      return unobserve();
    };
  }, [onChange, observe]);
  return /*#__PURE__*/_react["default"].createElement(Elem, (0, _extends2["default"])({}, rest, {
    ref: nodeRef
  }));
};

TrackInView.propTypes = {
  onChange: _propTypes["default"].func.isRequired,
  as: _propTypes["default"].elementType
};
var _default = TrackInView;
exports["default"] = _default;